import styled from 'styled-components';
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import { TableCell, TableContainer, Button, Modal } from '@mui/material'
import { BsArrowDownShort, BsGear } from "react-icons/bs";
import Box from '@mui/material/Box';
import { FaSearch } from 'react-icons/fa'
import { AiOutlineClear } from "react-icons/ai"
import { SiMicrosoftexcel } from "react-icons/si";
import { ImFilePdf } from "react-icons/im";
import { FaPlusCircle } from "react-icons/fa";
import CancelIcon from '@mui/icons-material/Cancel';

export const EyeOpen = styled(AiFillEye)`
  cursor: pointer;
  margin: 8px 0 -8px -35px;
  color: ${props => props.theme.colors.c02};
  z-index: 999
`;

export const EyeClose = styled(AiFillEyeInvisible)`
  cursor: pointer;
  margin: 8px 0 -8px -35px;
  color: ${props => props.theme.colors.c02};
  z-index: 999
`;

export const Page = styled.div`  
  width: 100%;
  display: flex;
  border-color: ${props => props.theme.colors.c12};
  background-color: transparent;
  color: ${props => props.theme.colors.c03};    
  justify-content: left;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 0 0 20px;
  padding: 0;
  position: relative;
  border-radius: 10px;  
  box-shadow: 2px 2px 5px 2px ${props => props.theme.colors.c12};
  height: 100%;
  min-height: 73.5vh;
`;

export const PageNoBg = styled.div`  
  width: 100%;
  display: flex;  
  justify-content: left;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 0 0 20px;
  padding: 0;
  position: relative;
  border-radius: 10px;  
  height: 100%;
  min-height: 73.5vh;
`;

export const LinePage = styled.div`
    display: flex;
    justify-content: left;
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 auto;   
    padding: 40px 30px;
`;

export const Border = styled.div`
  border: 1px solid ${props => props.theme.colors.c12};
  padding: 15px;
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px 0 50px;
`;
export const ErrorForm = styled.p`
padding-top:5px;
  text-align:right;
  color: ${props => props.theme.colors.c11};
`;

export const TitleText = styled.h2`
  color: ${props => props.theme.colors.c01};   
  text-transform: uppercase;
  font-size: 36px;
`;
export const DescText = styled.p`
  color: ${props => props.theme.colors.c01};   
  padding: 10px 0;
  font-weight: 200;
  font-size: 16px;
`;

//export const BtnUpload = styled(Button)`
export const BtnSave = styled(Button)`
  transition: all 0.2s;
  background-color: ${props => props.theme.colors.c01};
  color: ${props => props.theme.colors.c03};
  text-transform: none;
  weight: 100%;
  
  &:hover{
    opacity: 0.9;
    background-color: ${props => props.theme.colors.c01};
  }
`;
export const BtnUpload = styled.label`
  display: flex;  //btnUpload
  background-color: ${props => props.theme.colors.c01};
  color: ${props => props.theme.colors.c03};
  font-size: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px;
  border-radius: 4px
`;
export const BtnBack = styled(Button)`
  transition: all 0.2s;
  background-color: ${props => props.theme.colors.c01};
  color: ${props => props.theme.colors.c03};
  text-transform: none;
  border: ${props => props.theme.colors.c12},0.2;
  /* margin-left: 10px; */
  &:hover{
    opacity: 0.9,
  }
`;

export const PageTableContainer = styled(TableContainer)`
  width: 95%;  
  padding: 0 ;
  margin: 0;
`;

export const PageTableCellHead = styled(TableCell)`
  font-family: 'Calibri';
  color: ${props => props.theme.colors.c01};
  font-weight: 900;
  font-size: 17px  
`;

export const RegisterTableCellHead = styled(TableCell)`
  white-space: nowrap;
  padding-top: 30px;
  font-family: 'Calibri';
  color: ${props => props.theme.colors.c01};
  font-weight: 900;
  font-size: 17px  
`;

export const PageTableCellBody = styled(TableCell)`
  font-family: 'Calibri';
  color: ${props => props.theme.colors.c01};
  font-weight: 100;
  white-space: nowrap;
  font-size: 15px  
`;

export const PageTableIcon = styled.img`
  width: 20px;
  transition: all 0.2s;
  margin-right: 5px;
  &:hover{
    opacity: 0.5,
    cursor: pointer;
  }
`;
export const PageTableDownloadButton = styled(BsArrowDownShort)`
    transition: all 0.2s;
    width: 20px;
    height: 20px;
    color: black;
    border: 1px solid black;
    border-radius: 50%;
    margin-left: 7px;
    &:hover{
    opacity: 0.5;
    cursor: pointer;
  }
`;
export const PageTableEditButton = styled(BsGear)`
    transition: all 0.2s;
    width: 20px;
    height: 20px;
    color: black;
    /* border: 1px solid black; */
    border-radius: 50%;
    margin-right: 7px;
    &:hover{
    opacity: 0.5;
    cursor: pointer;
  }
`;
export const PageTableBtnBack = styled(Button)`
  margin: 50px 0 20px 20px;
  transition: all 0.2s;
  background: #fff;
  color: #043D5D;
  text-transform: none;
  border: 1px solid rgba(0,0,0,0.2);
  align-self: start;
  &:hover{
    background: #fff;
    opacity: 0.9
  }
`;

export const ModalContainer = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ModalBox = styled.section` 
  background-color: ${props => props.theme.colors.c01};   
  border-radius: 10px;
  padding: 10px;
  border: 0;
  /* min-width: 400px; */
  width: 800px;
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
`;
export const ModalBoxTitle = styled.h2` 
  color: ${props => props.theme.colors.c03} ;
  text-align: center;
  padding: 15px 0
`;

export const ModalBoxLabel = styled.label` 
  
`;
/*
 backgroundColor: theme.palette.background.paper,
  backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
*/
/* 
export const ColorPicker = styled.input`
  
`; */


export const Card = styled.button`
  width: 100%;
  height:100%;
  background: ${props => props.theme.colors.c01};
  border:1px solid ${props => props.theme.colors.c12};
  border-radius: 10px;
  padding: 15px 10px 10px;
  transition: all 0.2s;
  &:hover{
    cursor: pointer;
    border:1px solid ${props => props.theme.colors.c02};    
  } 
`;

export const CardImg = styled.div`
  width: 72px;
  height: 72px;
  background: ${props => props.theme.colors.c01};
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  margin: 0 auto;
`;

export const CardTitulo = styled.p`
    font-family: Calibri;
    font-size: 18px;
    line-height: 18px;
    margin:0;
    padding:5px 0 2px;
    color: ${props => props.theme.colors.c03};
`;

export const CardDetalhe = styled.p`
    font-family: Calibri;
    font-size: 14px;
  
    margin:0;
    padding:0;
    color: ${props => props.theme.colors.c03};
`;

export const ModalDetail = styled(Box)`
  position: absolute as absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: transparent;
  border:0;
  box-shadow:0;
  text-align: center;
  color: ${props => props.theme.colors.c04};
  /* padding: 4; */
`;

export const PageContainer = styled(Box)`
background: ${props => props.theme.colors.c04};
  width: 100%;
  margin-top: 65px
`;

export const TableBg = styled(Box)`
  background: ${props => props.theme.colors.c14};
  width: 100%;

`;

export const BtnPagination = styled(Button)`  
  padding: 0.3rem 0rem;
  border-radius: 0.5rem;
  border: 1px solid
    ${(props) => (props.theme.title === "light" ? props.theme.colors.c01 : props.theme.colors.c02)} !important ;
  transition: all 200ms linear !important;
  background-color: ${(props) =>
    props.theme.title === "light" ? props.theme.colors.c01 : props.theme.colors.c01 + 'DB'} !important;
  &:hover {
    opacity: 0.9 !important;
    background-color: ${(props) =>
    props.theme.title === "light" ? props.theme.colors.c02 : props.theme.colors.c02} !important;
    border: 1px solid
      ${(props) => (props.theme.title === "light" ? props.theme.colors.c01 : props.theme.colors.c02)} !important ;
  }
`;

export const PageCont = styled(Box)`
  position: relative;
  width: 100%;
  padding: 69px 10px 10px',;
  Background-color: ${props => props.theme.colors.c01};
  width: 100%,;
  border: 0;
  boxShadow: 0;
  height: 96vh;
  color:  ${props => props.theme.colors.c04}
`;

export const Titulo = styled.div`
  font-size: 20px;
  color: ${props => props.theme.colors.c02};
  padding: 5% 0 0 5%;
`;

export const IconeSearch = styled(FaSearch)`
  display: flex;
  color: ${props => props.theme.colors.c04};
  cursor: pointer;
  justify-content: flex-start;
  align-items: flex-start;

  &:hover{
    opacity: 0.7;
  }
`;

export const IconeAdd = styled(FaPlusCircle)`
  display: flex;
  color: ${props => props.theme.colors.c18};
  cursor: pointer;
  justify-content: flex-start;
  align-items: flex-start;
  position:relative;
  &:hover{
    opacity: 0.7;
  }
`;

export const IconExcel = styled(SiMicrosoftexcel)`
  display: flex;
  color: ${props => props.theme.colors.c04};;
  cursor: pointer;
  justify-content: flex-start;
  align-items: flex-start;
  position:relative;
  margin-left: 5%;
  &:hover{
    opacity: 0.7;
  }
`;

export const IconPdf = styled(ImFilePdf)`
  display: flex;
  color: ${props => props.theme.colors.c04};;
  cursor: pointer;
  justify-content: flex-start;
  align-items: flex-start;
  position:relative;
  margin-left: 5%;
  &:hover{
    opacity: 0.7;
  }
`;

export const IconClear = styled(AiOutlineClear)`
  display: flex;
  color: ${props => props.theme.colors.c04};;
  cursor: pointer;
  justify-content: flex-start;
  align-items: flex-start;
  position:relative;
  &:hover{
    opacity: 0.7;
  }
`;

export const SearchContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 94%;
  /* padding: 15px 0; */
  @media (max-width: 800px){
    width: 100%;
    flex-direction:column
  }
`;
export const SearchRow = styled.div`
  width:98%;
  display:flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  position:relative;
  @media (max-width: 800px){
    flex-direction: column;
    justify-content: center;
    align-items:center
  }
`;
export const SearchBox = styled.div`
  background-color: ${props => props.theme.colors.c02};
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.2);
  margin: 20px 15px 20px 0;
  padding: 0;
  border-radius: 7px;
  width: 93.7%;
  @media (max-width: 800px){
    margin: 20px 15px;
    padding-bottom:20px
  }
`;

export const Items = styled.div`
  display: flex;
  justify-content:flex-end;
  align-items: flex-end;
  width: 100%;
  height: 60px;
  @media (max-width: 800px){
    width: 60%;
    justify-content: center;
  }
`;

export const ItemsSearch = styled.div`
  display: flex;
  justify-content:left;
  align-items: flex-end;
  width: 100%;
  height: 48px;
  @media (max-width: 800px){
    width: 100%;
    justify-content: left;
    align-items: left;
    margin-top: 10px;
  }
`;
export const StyledModal = styled.div`
  background-color: ${props => props.theme.colors.c01};
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  border: 0;
  boxShadow: 24;
  borderRadius: 10px;
`;

export const TitleModal = styled.h2`    
  margin: 0;
  font-size: 14px;
  line-height: 25px;
  padding-left: 10px;
  border-top-left-radius: 5px;
  height:25px;
  border-top-right-radius: 5px;
  font-weight:bold;
  text-transform:uppercase;
  color: ${props => props.theme.colors.c05} !important;
  background-color: ${props => props.theme.colors.c02};
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const Content = styled.div`
  background: ${props => props.theme.colors.c01};
  padding:0;
  border-radius: 5px;
  width: 60%;
  max-width: 90%;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);
`;

export const OverlayMobile = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ContentMobile = styled.div`
  background: ${props => props.theme.colors.c01};
  padding:0;
  border-radius: 5px;
  width: 60%;
  max-width: 90%;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);
`;

export const ContentRegister = styled.div`
  background: ${props => props.theme.colors.c01};
  padding:0;
  border-radius: 5px;
  width: 29%;
  max-width: 90%;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);
`;

export const CloseModalRegister = styled(CancelIcon)`
 position: fixed;
  display: flex;
  margin-top: -25px;
  right: 35.6%; 
  float:left;
  writing-mode: vertical-rl;
  color: ${props => props.theme.colors.c05};
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
`;

export const ContentRegisterMobile = styled.div`
  background: ${props => props.theme.colors.c01};
  padding:0;
  border-radius: 5px;
  width: 95%;
  max-width: 95%;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);
`;

export const CloseModalRegisterMobile = styled(CancelIcon)`
 position: fixed;
  display: flex;
  margin-top: -25px;
  right: 2.5%; 
  float:left;
  writing-mode: vertical-rl;
  color: ${props => props.theme.colors.c05};
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
`;

export const CloseModal = styled(CancelIcon)`
 position: fixed;
  display: flex;
  margin-top: -25px;
  right: 20%; 
  float:left;
  writing-mode: vertical-rl;
  color: ${props => props.theme.colors.c05};
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
`;

export const ContentEdit = styled.div`
  background: ${props => props.theme.colors.c01};
  padding:0;
  border-radius: 5px;
  width: 90%;
  max-width: 90%;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);
`;

export const CloseModalEdit = styled(CancelIcon)`
 position: fixed;
  display: flex;
  margin-top: -25px;
  right: 5%; 
  float:left;
  writing-mode: vertical-rl;
  color: ${props => props.theme.colors.c05};
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
`;

export const ContentPeriodo = styled.div`
  background: ${props => props.theme.colors.c01};
  padding:0;
  border-radius: 5px;
  width: 45%;
  max-width: 90%;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);
`;

export const CloseModalPeriodo = styled(CancelIcon)`
 position: fixed;
  display: flex;
  margin-top: -25px;
  right: 27.5%; 
  float:left;
  writing-mode: vertical-rl;
  color: ${props => props.theme.colors.c05};
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
`;

export const CloseButton = styled.button`
  background-color: ${props => props.theme.colors.c13};
  color: white;
  border: none;
  padding: 8px 12px;
  margin-top: 10px;
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    background: ${props => props.theme.colors.c13};
    opacity: 0.7;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const Btn = styled(Button)`
  background-color: ${props => props.theme.colors.c02};
  margin: 10px;
  cursor: pointer;
  &:hover{
    background: ${props => props.theme.colors.c02};
    opacity: 0.7;
  }
`;

export const BtnRegister = styled(Button)`
  margin: 10px;
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
`;

export const BtnCancel = styled(Button)`
  background-color: ${props => props.theme.colors.c13};
  margin: 10px;
  cursor: pointer;
  &:hover{
    background: ${props => props.theme.colors.c13};
    opacity: 0.7;
  }
`;

export const InputObs = styled.input`
height: 30px;
outline: 0;
border-radius: 5px;
padding-left: 10px;
width: 100%;
border: 1px;
color: ${props => props.theme.colors.c04};
background-color: ${props => props.theme.colors.c16};
margin: 0;
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ddd;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #ddd;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: #ddd;
}
`;

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});